var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendToAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.79547L18.9443 7.84222L11.1974 16H0L7.81371 7.79547L0.400703 0H11.5759L18.9443 7.73703L19 7.79547Z",
    fill: "#DB0011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToAll);
export default __webpack_public_path__ + "static/media/sendToAll.a1d6afa8dc55f82fdcd06c545403a40c.svg";
export { ForwardRef as ReactComponent };